import styled from 'styled-components';
import { sizes } from 'style';
import { motion } from 'framer-motion6';

export const ScaleWrapper = styled.div`
  width: 100%;
  height: 184px;
  margin-top: 53px;
  z-index: 3;
  display: none;

  @media ${sizes.tabletLandscape} {
    display: block;
  }
`;

export const BenefitContainer = styled(motion.div)`
  width: 100%;
  max-width: 860px;
  padding: 32px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.black};
  transition: 200ms;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;

  > svg {
    color: ${({ theme }) => theme.colors.white};
    height: 18px;
    width: auto;
  }

  > h3 {
    margin: 0;
    font-size: 24px;
    line-height: 24px;
    margin-left: 8px;
  }
`;

export const Description = styled.p`
  margin: 0;
  margin-top: 18px;
  font-size: 18px;
  line-height: 26px;
`;
